export default __webpack_public_path__ + "static/media/clothesButton.657148cf.jpg";